import NotificationPopper from './NotificationPopperContainer';

export default NotificationPopper;
